import React, { useState } from "react";
import CustomerListTable from "../customer/CustomerListTable";
import ExpenseHeader from "./ExpenseHeader";
import TailwindTable from "../customer/TailwindTable";
import TableComponent from "../UniversalComponents/TableComponent";

const Payments = () => {
  const [paginationData, setPaginationData] = useState(null);

  return (
    <div className="mt-2">
      {/* <div className="border flex gap-10 ps-4 p-2 ">
        {header.map((item, index) => (
          <div key={index} className="text-12 text-1D4469 font-400 ">
            {item}
          </div>
        ))}
      </div> */}

      <div className="mt-10">
        <TableComponent name="categoryDetails" />
        <TableComponent name="itemDetails" />
        {/* <CustomerListTable
          key=""
          tableDetail={{
            tableidclass: "fullscreen-table z-customer-45",
            tableparentidclass: "tableparent",
            tablename: "",
            TableLeadFilter: "",
            tableHeading: "Customer Table",
            tablenameclass: "font-medium text-xl text-203C50 capitalize",
            tableSearch: true,
            tableFilter: true,
            tableResizer: true,
            tableZoom: true,
            tableheader: true,
            addbutton: "",
          }}
          totalData=""
          thead={ExpenseHeader}
          handlePostThead=""
          tbody=""
          tablePaginationData={setPaginationData}
          setCustomerPayload=""
          fetchtableBodyData=""
          customerCommnData=""
          fetchPersonInTable=""
          TableFieldUpdate=""
          ExtraFieldAddHeader=""
          GetAdditionalField=""
          GetAddFieldData=""
          initialFilter=""
          stickyHeaders=""
          handleNavigate=""
          navigateNameCondition={["customer_display_name", "customer_name"]}
          refetchCustomerData=""
          activeFilterTab=""
          setActiveFilterTab=""
          isListLoading=""
          ExtraFieldComponent=""
        /> */}
      </div>
    </div>
  );
};

export default Payments;
